module.exports = __webpack_public_path__ + "img/GTE.b9363018.svg";